import MultiFactorAuthentication from './MultiFactorAuthentication';

export default MultiFactorAuthentication;
